import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import PartnersPage from "@/pages/partners/page";
import EventsPage from "@/pages/events/page";
import EventDetailPage from "@/pages/events/[id]/page";
import AboutPage from "@/pages/about/page";
import GuestsPage from "@/pages/guests/page";
import PaymentSuccess from "@/pages/payment/Success";
import DisclaimerPage from "@/pages/legal/DisclaimerPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import AdminLayout from "@/pages/admin/components/AdminLayout";
import AdminLoginPage from "@/pages/admin/login/page";
import AdminDashboard from "@/pages/admin/dashboard/page";
import RegistrationsPage from "@/pages/admin/registrations/page";
import ApplicationsPage from "@/pages/admin/applications/page";
import AdminGuestsPage from "@/pages/admin/guests/page";
import AdminDonorsPage from "@/pages/admin/donors/page";
import AdminMediaPage from "@/pages/admin/media/page";
import AdminEventsPage from "@/pages/admin/events/page";
import AdminStaffPage from "@/pages/admin/staff/page";
import EmailConfigPage from "@/pages/admin/email-config/page";
import AdminSubscriptionsPage from "@/pages/admin/subscriptions/page";
import AdminTeamsPage from "@/pages/admin/teams/page";
import AdminMilestonesPage from "@/pages/admin/milestones/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/partners", element: <PartnersPage /> },
  { path: "/events", element: <EventsPage /> },
  { path: "/events/:id", element: <EventDetailPage /> },
  { path: "/guests", element: <GuestsPage /> },
  { path: "/payment/success", element: <PaymentSuccess /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "registrations", element: <RegistrationsPage /> },
      { path: "applications", element: <ApplicationsPage /> },
      { path: "guests", element: <AdminGuestsPage /> },
      { path: "donors", element: <AdminDonorsPage /> },
      { path: "media", element: <AdminMediaPage /> },
      { path: "events", element: <AdminEventsPage /> },
      { path: "staff", element: <AdminStaffPage /> },
      { path: "email-config", element: <EmailConfigPage /> },
      { path: "subscriptions", element: <AdminSubscriptionsPage /> },
      { path: "teams", element: <AdminTeamsPage /> },
      { path: "milestones", element: <AdminMilestonesPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
